import React, { PureComponent } from 'react';
import { Container } from 'react-bootstrap';
import Head from 'next/head';
import { FaFacebook } from 'react-icons/fa';
import flow from 'lodash.flow';

import { i18n, withTranslation } from '../../i18n';
import AuthService from '../../services/Auth';
import withoutAuth from '../../services/Auth/withoutAuth';
import { setToken } from '../../services/Auth/actions';
import withTranslations from '../../services/Translations/withTranslations';
import Translation from '../../services/Translations/Translation';
import { routerPush } from '../../utils/router';
import BannerLayout from '../../layouts/Banner';
import Link from '../../components/Navigation/Link';
import ProfileForm from '../../components/ProfileForm';
import Button from '../../components/UI/Button';
import PageTitle from '../../components/UI/PageTitle';
import Separator from '../../components/UI/Separator';
import Error from '../../components/Forms/Error';
import styles from './styles.css';
import RegisterWithEmailForm from './RegisterWithEmailForm';

class Join extends PureComponent {
  state = {
    isRegisteringWithFacebook: false,
    facebookProfile: null,
    facebookLoginError: null,
  };

  static async getInitialProps() {
    return {
      namespacesRequired: ['common'],
    };
  }

  handleRegisterWithFacebook = () => {
    window.openFB.login(this.handleRegisterWithFacebookCallback, { scope: 'email' });
    this.setState({ isIsRegisteringWithFacebook: true, facebookLoginError: null });
  };

  handleRegisterWithFacebookCallback = async fbLoginResponse => {
    if (!fbLoginResponse.status || fbLoginResponse.status !== 'connected') {
      this.setState({ isIsRegisteringWithFacebook: false });
      return;
    }

    let response;
    try {
      response = await AuthService.facebookRegister(undefined, fbLoginResponse.authResponse.accessToken);
    } catch (error) {
      this.setState({
        isIsRegisteringWithFacebook: false,
        facebookLoginError: error && error.body && error.body.error,
      });
      return;
    }

    if (response.token) {
      AuthService.storeToken(response.token);
      setToken(response.token);
      routerPush('/profile');
      return;
    }

    this.setState({
      isIsRegisteringWithFacebook: false,
      facebookProfile: response.user,
    });
  };

  render() {
    const { t } = this.props;
    const { facebookProfile, isIsRegisteringWithFacebook, facebookLoginError } = this.state;

    return (
      <BannerLayout small={!facebookProfile}>
        <Head>
          <title>
            {t('siteTitle')} | {t('join')}
          </title>
        </Head>
        <PageTitle as="h2" alignment="center" className="mb-4">
          {t('join')}
        </PageTitle>
        {!facebookProfile && (
          <>
            <div className="mb-5">
              <Translation namespace="join" t="introText" type="html" />
            </div>
            <RegisterWithEmailForm />
            <Separator className="mt-4 mb-4" label={t('or')} />
            <Button
              level="facebook"
              type="button"
              processing={isIsRegisteringWithFacebook}
              fullWidth
              onClick={this.handleRegisterWithFacebook}
              icon={<FaFacebook />}
            >
              {t('registerWithFacebook')}
            </Button>
            {facebookLoginError && <Error className="mt-3">{facebookLoginError}</Error>}

            <p className={styles.alreadyRegistered}>
              {t('alreadyRegistered')}{' '}
              <Link href="/login">
                <a>{t('logIn')}</a>
              </Link>
            </p>
          </>
        )}

        {facebookProfile && <ProfileForm mode="register" user={facebookProfile} serviceProfile={{}} />}
      </BannerLayout>
    );
  }
}

export default flow(
  withTranslations(['join']),
  withTranslation('common'),
  withoutAuth,
)(Join);
